import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const Header: StyleRule = () => ({
    [`& > div`]: {
        padding: pxArrayToRem([0, 18]),
    },
});

export const FilmsGrid: StyleRule = () => ({
    gap: pxArrayToRem([32, 6]),
});

export const ViewMore: StyleRule = () => ({
    margin: pxArrayToRem([30, 18, 14]),
});
